module.exports = __webpack_public_path__ + "static/img/yeswecan0009.2857571.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0009.png
// module id = 575
// module chunks = 1